import { useQuery } from '@tanstack/react-query';
import React from 'react';

import envVars from '../../../../../constants/envVars';
import useRequest from '../../../../../hooks/useRequest';
import { memberClinicalDataMock } from '../mockData';
import { ApiEnvelope } from '../../../types';
import { MemberClinicalData } from '../types';
import { MEMBER_CLINICAL_DATA_KEY } from './constants';

const useGetMemberClinicalData = (member_id: number | null | undefined, includeRemoved = false) => {
    const req = useRequest();

    const request = React.useCallback(() => {
        if (envVars.USE_EHR_MOCK_DATA) {
            return Promise.resolve(memberClinicalDataMock);
        }

        return req<ApiEnvelope<MemberClinicalData>>({
            url: `${envVars.API_RTM_HOSTNAME}enterprise/member/${member_id}/clinical/`,
            ...(includeRemoved && { query: { include_removed: 'true' } })
        });
    }, [member_id, includeRemoved, req]);

    return useQuery({
        queryKey: [MEMBER_CLINICAL_DATA_KEY, member_id, includeRemoved],
        queryFn: request,
        // `useRequest` hands back the raw body, so unwrap the envelope here rather
        // than making every section reach through `data.data`.
        select: (response) => response.data,
        enabled: !!member_id
    });
};

export default useGetMemberClinicalData;
